import React from 'react';
import FormField from '../molecules/FormField';
import Input from '../atoms/Input';
import Select from '../atoms/Select';

export const ROLE_OPTIONS = ['Store Staff', 'Manager', 'Supervisor', 'Admin'];
const BOOLEAN_OPTIONS = ['Yes', 'No'];

export default function TableCard({ name, level, value, onChange }) {
  const data = value ?? {};
  const updateField = (field, nextValue) => onChange?.({ ...data, [field]: nextValue });
  const accent = level === 1 ? 'green' : level === 2 ? 'orange' : 'blue';
  const fieldId = (field) => `workflow-level-${level}-${field}`;

  return (
    <article className={`ca-table-card ca-table-card--${accent}`}>
      <header className="ca-table-card__header">
        <span className="ca-table-card__level">L{level}</span>
        <div>
          <h3 className="ca-table-card__title">{name}</h3>
          <p className="ca-table-card__subtitle">Initial Handler</p>
        </div>
      </header>
      <div className="ca-table-card__divider" />
      <div className="ca-table-card__fields">
        <FormField label="Select Role" htmlFor={fieldId('role')}>
          <Select id={fieldId('role')} value={data.role} options={ROLE_OPTIONS} placeholder="Select role" onChange={(event) => updateField('role', event.target.value)} />
        </FormField>
        <FormField label="Can Resolve" htmlFor={fieldId('canResolve')}>
          <Select id={fieldId('canResolve')} value={data.canResolve} options={BOOLEAN_OPTIONS} onChange={(event) => updateField('canResolve', event.target.value)} />
        </FormField>
        <FormField label="Can Reassign" htmlFor={fieldId('canReassign')}>
          <Select id={fieldId('canReassign')} value={data.canReassign} options={BOOLEAN_OPTIONS} onChange={(event) => updateField('canReassign', event.target.value)} />
        </FormField>
        <FormField label="Final Level" htmlFor={fieldId('finalLevel')}>
          <Select id={fieldId('finalLevel')} value={data.finalLevel} options={BOOLEAN_OPTIONS} onChange={(event) => updateField('finalLevel', event.target.value)} />
        </FormField>
        <FormField label="Escalation time" htmlFor={fieldId('escalationTime')}>
          <div className="ca-table-card__time-input">
            <Input id={fieldId('escalationTime')} type="number" min="0" value={data.escalationTime ?? ''} placeholder="--" onChange={(event) => updateField('escalationTime', event.target.value)} />
            <span>minutes</span>
          </div>
        </FormField>
      </div>
    </article>
  );
}